import ChatPreviewSkeleton from './chat-preview-skeleton'

const ChatListSkeleton = () => {
  return (
    <div className="flex flex-col">
      <ChatPreviewSkeleton />
      <ChatPreviewSkeleton />
      <ChatPreviewSkeleton />
      <ChatPreviewSkeleton />
      <ChatPreviewSkeleton />
    </div>
  )
}

export default ChatListSkeleton
